<div class="cerrix-documents-list">
    @if (!!documents) {
        <div class="documents-list">
            @for (document of documents; track document; let i = $index) {
                <div class="document-item">
                    <div>
                        <div class="document-text">
                            {{ document.name }}
                        </div>
                        @if (document.modifiedOn || document.createdOn) {
                            <div class="document-date">
                                Updated:
                                {{ document.modifiedOn ?? document.createdOn | dateTimeDisplay }}
                            </div>
                        }
                    </div>
                    <div class="document-actions">
                        @if (document.name.toLowerCase().endsWith(".pdf")) {
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'document-' + i + '-open-button'"
                                (click)="onOpenPdfDocument(document)"
                            >
                                <mat-icon fontSet="material-symbols-outlined"
                                    >find_in_page</mat-icon
                                >
                            </cerrix-icon-button>
                        }
                        @if (canEdit) {
                            <cerrix-icon-button
                                color="accent-link"
                                size="small"
                                [dataUiid]="'document-' + i + '-edit-button'"
                                (click)="onEditDocument(document)"
                            >
                                <mat-icon fontSet="material-symbols-outlined"
                                    >edit_square_outlined</mat-icon
                                >
                            </cerrix-icon-button>
                        }
                        <cerrix-icon-button
                            color="accent-link"
                            size="small"
                            [dataUiid]="'document-' + i + '-download-button'"
                            (click)="onFileDownload(document)"
                        >
                            <mat-icon fontSet="material-symbols-outlined">cloud_download</mat-icon>
                        </cerrix-icon-button>
                        @if (canDelete) {
                            <cerrix-confirmation-button
                                btnLabel="Delete?"
                                [dataUiid]="'document-' + i + '-delete-button'"
                                (onConfirmationClick)="onRemoveFile(document)"
                            >
                            </cerrix-confirmation-button>
                        }
                    </div>
                </div>
            }
        </div>
        @if (documents.length === 0) {
            <div class="documents-list">
                <div class="document-item">
                    <div class="document-text">No documents available</div>
                </div>
            </div>
        }
    }

    @if (canAdd) {
        <cerrix-drop-area
            [dataUiid]="dataUiid + '-drop-area'"
            (onFileSelection)="onFileSelection($event)"
        ></cerrix-drop-area>
    }
</div>
